import { render, staticRenderFns } from "./BtnRetornarPagamento.vue?vue&type=template&id=48c8c7cb"
import script from "./BtnRetornarPagamento.vue?vue&type=script&lang=js"
export * from "./BtnRetornarPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports